import React, { useState, useEffect } from 'react';
import { FiMail, FiAlertCircle, FiCheckCircle, FiX } from 'react-icons/fi';
import { emailService } from '../../services/emailService';

const EmailStatusChecker = () => {
  const [emailStatus, setEmailStatus] = useState('checking');
  const [showBanner, setShowBanner] = useState(true);
  
  useEffect(() => {
    checkEmailConfiguration();
  }, []);

  const checkEmailConfiguration = () => {
    const emailjsConfigured = !!(
      import.meta.env.VITE_EMAILJS_PUBLIC_KEY &&
      import.meta.env.VITE_EMAILJS_SERVICE_ID &&
      import.meta.env.VITE_EMAILJS_TEMPLATE_ID
    );

    if (emailjsConfigured) {
      setEmailStatus('configured');
    } else {
      setEmailStatus('not-configured');
      console.warn('⚠️ Email notifications not configured!');
      console.log('📧 To receive form notifications:');
      console.log('1. Go to https://www.emailjs.com');
      console.log('2. Sign up for free account');
      console.log('3. Follow setup in EMAIL_SETUP_GUIDE.md');
    }
  };

  const sendTestEmail = async () => {
    const result = await emailService.sendContactNotification({
      name: 'Test User',
      email: 'test@example.com',
      phone: '555-0123',
      service: 'Test Service',
      message: 'This is a test email from your website.'
    });

    if (result.success) {
      alert('✅ Test email sent successfully! Check your inbox.');
    } else {
      alert(`❌ Email failed: ${result.error}`);
    }
  };

  if (emailStatus === 'configured' || !showBanner) {
    return null;
  }

  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <FiAlertCircle className="h-5 w-5 text-yellow-400" />
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm text-yellow-700">
            <strong>Email notifications are not configured!</strong> You won't receive alerts when customers fill out forms.
          </p>
          <p className="mt-2 text-sm text-yellow-700">
            Quick fix: Set up EmailJS in 5 minutes for free notifications.
          </p>
          <div className="mt-3">
            <a
              href="https://www.emailjs.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-yellow-700 underline hover:text-yellow-600 mr-4"
            >
              Set up EmailJS →
            </a>
            <button
              onClick={() => window.open('/EMAIL_SETUP_GUIDE.md', '_blank')}
              className="text-sm font-medium text-yellow-700 underline hover:text-yellow-600 mr-4"
            >
              View Setup Guide
            </button>
            <button
              onClick={sendTestEmail}
              className="text-sm font-medium text-yellow-700 underline hover:text-yellow-600"
            >
              Test Email
            </button>
          </div>
        </div>
        <div className="ml-auto pl-3">
          <button
            onClick={() => setShowBanner(false)}
            className="inline-flex text-yellow-400 hover:text-yellow-500"
          >
            <FiX className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailStatusChecker;
